import React from 'react'
import {
    Edit,
    SimpleForm,
    TextInput,
    FunctionField,
    ArrayInput,
    SimpleFormIterator,
    ReferenceInput,
    DateInput,
    SelectInput,
} from 'react-admin'

const RecordingEdit = (props) => (
    <Edit title="Edit User" {...props}>
        <SimpleForm>
            <TextInput fullWidth source="title" label="Title" />
            <TextInput
                multiline
                fullWidth
                source="description"
                label="Description"
            />
            <FunctionField
                label="Recording Path"
                render={(record) =>
                    record?.tempResourceUrl ||
                    record?.azureResourceUrl ||
                    record?.path ||
                    record?.url ||
                    '-'
                }
            />
            <ArrayInput source="_transcripts" label="Transcripts">
                <SimpleFormIterator>
                    <TextInput
                        fullWidth
                        source="path"
                        label="Transcript Path"
                        disabled={true}
                    />
                    <TextInput
                        fullWidth
                        source="name"
                        label="Transcript name"
                    />
                    <div style={{ display: 'flex' }}>
                        <ReferenceInput
                            source="uploaderId"
                            reference="users"
                            label="Uploader"
                        >
                            <SelectInput
                                optionText="name"
                                disabled={true}
                                label="Name"
                            />
                        </ReferenceInput>
                        <DateInput
                            source="createdAt"
                            disabled={true}
                            label="Upload Date"
                        />
                    </div>
                </SimpleFormIterator>
            </ArrayInput>
            <ArrayInput source="_imageCaptions" label="Image Captions">
                <SimpleFormIterator>
                    <TextInput
                        fullWidth
                        source="path"
                        label="Transcript Path"
                        disabled={true}
                    />
                    <TextInput
                        fullWidth
                        source="name"
                        label="Transcript name"
                    />
                    <div style={{ display: 'flex' }}>
                        <ReferenceInput
                            source="uploaderId"
                            reference="users"
                            label="Uploader"
                        >
                            <SelectInput
                                optionText="name"
                                disabled={true}
                                label="Name"
                            />
                        </ReferenceInput>
                        <DateInput
                            source="createdAt"
                            disabled={true}
                            label="Upload Date"
                        />
                    </div>
                </SimpleFormIterator>
            </ArrayInput>
            <ArrayInput disabled source="_soundCaptions" label="Sound Captions">
                <SimpleFormIterator>
                    <TextInput
                        fullWidth
                        source="path"
                        label="Transcript Path"
                        disabled={true}
                    />
                    <TextInput
                        fullWidth
                        source="name"
                        label="Transcript name"
                        disabled={true}
                    />
                    <div style={{ display: 'flex' }}>
                        <ReferenceInput
                            source="uploaderId"
                            reference="users"
                            label="Uploader"
                        >
                            <SelectInput
                                optionText="name"
                                disabled={true}
                                label="Name"
                            />
                        </ReferenceInput>
                        <DateInput
                            source="createdAt"
                            disabled={true}
                            label="Upload Date"
                        />
                    </div>
                </SimpleFormIterator>
            </ArrayInput>
            <ReferenceInput source="uploaderId" reference="users">
                <SelectInput optionText="name" disabled={true} />
            </ReferenceInput>
            <DateInput
                source="createdAt"
                label="Upload Date"
                disabled={true}
            />
        </SimpleForm>
    </Edit>
)

export default RecordingEdit
